import {patchState, signalStore, withMethods, withState} from "@ngrx/signals";
import {withStorageSync} from "@angular-architects/ngrx-toolkit";

export type AppSettingsState = {
  player: {
    enabled: boolean;
  },
  darkTheme: boolean | undefined;
}

const initialState: AppSettingsState = {
  player: {
    enabled: true
  },
  darkTheme: undefined
}

export const AppSettingsStore = signalStore(
  withStorageSync('app-settings'),
  withState(initialState),
  withMethods((store) => ({
      setPlayerEnabled(enabled: boolean) {
        patchState(store, {
          player: {
            ...store.player(),
            enabled
          }
        });
      },
      setDarkTheme(darkTheme: boolean) {
        patchState(store, {
          darkTheme
        });
      }
    })
  ));
